import {IModalService} from "angular-ui-bootstrap";
import {IPromise} from "angular";
import {LodgeAmountDialogController} from "./LodgeAmountDialog";

export class LodgeAmountService {

    public static id = "lodgeAmountService";

    /** @ngInject */
    public constructor(private $uibModal: IModalService) {

    }

    public open(title: string, max: number): IPromise<number> {
        const instance = this.$uibModal.open({
            templateUrl: "app/portfolio/templates/collateral/service/lodge-amount/LodgeAmountDialog.html",
            backdrop: "static",
            size: "sm",
            controllerAs: "ctrl",
            controller: LodgeAmountDialogController,
            resolve: {
                title: () => title,
                max: () => max
            }
        });
        return instance.result;
    }

    public openLodgeAmount(max: number): IPromise<number> {
        return this.open("Amount to Lodge", max);
    }

    public openUnlodgeAmount(max: number): IPromise<number> {
        return this.open("Amount to Unlodge", max);
    }
}
